module.exports = __webpack_public_path__ + "static/media/macro-banner.3119b2c8.svg";